// extracted by mini-css-extract-plugin
export default {"pageWrapper":"DashboardPage_pageWrapper__WrHc5","contentWrapper":"DashboardPage_contentWrapper__YVnNg"};